import type {
  BackgroundValue,
  ImageAnimationEffectType
} from '@elfsight/configurator-contracts';

export interface WidgetBackgroundSettings {
  widgetBackground: BackgroundValue;
  widgetHorizontalPadding: number;
  widgetVerticalPadding: number;
  widgetImageAnimationType?: ImageAnimationEffectType;
}

export const widgetBackgroundDefaultSettings: WidgetBackgroundSettings = {
  widgetBackground: {
    type: 'color',
    color: 'transparent',
    borderRadius: 24
  },
  widgetHorizontalPadding: 40,
  widgetVerticalPadding: 40,
  widgetImageAnimationType: 'none'
};
